export default "__VITE_ASSET__CeKjqSm0__"